import { apiGet } from '@/store/api';

export async function getApplicableVesselName(vesselName: string, vesselID: number, portcallID: number) {
    const result = await apiGet(`vessel/${vesselID}/portcall/${portcallID}`)
    return result ?? vesselName;
}
